import type { ButtonHTMLAttributes, Ref } from "react";
import "./button.css";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
  /** Arriva al `<button>` (in React 19 `ref` è una prop), per riportarvi il focus. */
  ref?: Ref<HTMLButtonElement>;
};

// `className` viene unita alla classe base, non sostituita: un chiamante può
// aggiungere stili senza perdere `g-button` e la variante.
export function Button({ variant = "secondary", type = "button", className, ...rest }: Props) {
  const classes = className ? `g-button ${className}` : "g-button";
  return <button type={type} data-variant={variant} className={classes} {...rest} />;
}
